module.exports = __webpack_public_path__ + "static/Sonyax4f-7660477a5338f28090b6f0185ea1c2ea.png";